<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
  Download rapport for brik {{ data.idTag.printedId }}
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="downloadReportFormGroup" (submit)="downloadReport()">
  <mat-dialog-content>
    <div class="form-row mat-date-range-input">
      <mat-form-field>
        <mat-label>Periode</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input formControlName="startDate" class="pointer" readonly matStartDate placeholder="Start dato" #dateRangeStart />
          <input formControlName="endDate" class="pointer" readonly matEndDate placeholder="Slut dato" #dateRangeEnd />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker">
          <svg matDatepickerToggleIcon class="icon-24">
            <use href="/assets/images/ok-icons-sprite.svg#calendar-s"></use>
          </svg>
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="unit-identifier">
      <span>Brik ID:</span>
      {{ data.idTag.printedId }}
    </div>
    <div>
      <button mat-dialog-close type="button" mat-button>Annuller</button>
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="downloadReportFormGroup.invalid || loading"
        [class.spinner]="loading">
        Download rapport
      </button>
    </div>
  </mat-dialog-actions>
</form>
